import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, consultarDetalheSolicitacao } from './types';

export const INITIAL_STATE: consultarDetalheSolicitacao = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultarDetalheSolicitacao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_DETALHE_SOLICITACAO_REQUEST: {
				draft.data = INITIAL_STATE.data;
				draft.status = 100;
				break;
			}

			case Types.CONSULTAR_DETALHE_SOLICITACAO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_DETALHE_SOLICITACAO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTAR_DETALHE_SOLICITACAO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
